<mat-card>
  <div align="center">
    <form class="form">
      <div  align="center">
        <label (click)="goHome()" style="text-decoration:underline;cursor: pointer;">Ir al Menú</label>
      </div>
    </form>
  </div>
</mat-card>